import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#6E84A1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.334 5c0-.736.597-1.333 1.333-1.333h10.667c.736 0 1.333.597 1.333 1.333v6c0 .736-.597 1.334-1.333 1.334H2.667A1.333 1.333 0 0 1 1.334 11zm8.333 3a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0M3.834 8h.007m8.32 0h.006" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }